import httpClientNews from '../api/httpClientNews';

export const getAllNews = async ({ pageNumber = 1, pageSize = 10 } = {}) => {
  const response = await httpClientNews.get('/api/cms/NewsManagement/GetAll', {
    params: { pageNumber, pageSize },
  });
  return response.data;
};

export const createNews = async (payload) => {
  const response = await httpClientNews.post('/api/cms/NewsManagement/Create', payload);
  return response.data;
};

export const createNewsWithGallery = async ({ dto, galleryImages = [] }) => {
  const formData = new FormData();
  formData.append('dto', JSON.stringify(dto));
  (galleryImages || []).forEach((file) => {
    if (file instanceof File) formData.append('galleryImages', file, file.name);
  });
  const response = await httpClientNews.post('/api/cms/NewsManagement/CreateWithGallery', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const uploadNewsImage = async ({ newsId, file }) => {
  const formData = new FormData();
  if (newsId) formData.append('NewsId', newsId);
  if (file instanceof File) formData.append('Image', file, file.name);
  const response = await httpClientNews.post('/api/cms/NewsManagement/UploadImage', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const uploadNewsImages = async ({ newsId, files = [] }) => {
  const formData = new FormData();
  if (newsId) formData.append('NewsId', newsId);
  files.forEach((file) => {
    if (file instanceof File) formData.append('Images', file, file.name);
  });
  const response = await httpClientNews.post('/api/cms/NewsManagement/UploadImages', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const deleteNews = async (id) => {
  const response = await httpClientNews.delete(`/api/cms/NewsManagement/Delete/${id}`);
  return response.data;
};

export const getNewsById = async (id) => {
  const response = await httpClientNews.get(`/api/cms/NewsManagement/GetById/${id}`);
  return response.data;
};

export const reorderNewsImages = async ({ newsId, imageIdsInOrder }) => {
  const response = await httpClientNews.post('/api/cms/NewsManagement/ReorderImages', {
    newsId,
    imageIdsInOrder,
  });
  return response.data;
};

export const removeNewsImage = async ({ newsId, imageId }) => {
  const response = await httpClientNews.delete(`/api/cms/NewsManagement/RemoveImage/${newsId}/${imageId}`);
  return response.data;
};

export const updateNews = async ({ id, title, summary, content, isActive, order }) => {
  const response = await httpClientNews.put('/api/cms/NewsManagement/Update', {
    id,
    title,
    summary,
    content,
    isActive,
    order,
  });
  return response.data;
};

export default {
  getAllNews,
  createNews,
  createNewsWithGallery,
  uploadNewsImage,
  uploadNewsImages,
  deleteNews,
  getNewsById,
  reorderNewsImages,
  removeNewsImage,
  updateNews,
};


